import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "stepFooter", "nextButton", "saveButton", "nameInput", "memberItems"]

  connect() {
    this.currentStep = 0
    this.showStep()
    this.refreshNext()
    this.refreshSave()

    if (this.hasMemberItemsTarget) {
      this.observer = new MutationObserver(() => this.refreshSave())
      this.observer.observe(this.memberItemsTarget, { childList: true })
    }
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  next(event) {
    event.preventDefault()
    if (!this.nameValid()) return
    this.currentStep = 1
    this.showStep()
    this.refreshSave()
  }

  back(event) {
    event.preventDefault()
    this.currentStep = 0
    this.showStep()
  }

  nameChanged() {
    this.refreshNext()
  }

  selectionChanged() {
    this.refreshSave()
  }

  nameValid() {
    return this.hasNameInputTarget && this.nameInputTarget.value.trim().length > 0
  }

  hasAnySelection() {
    const memberCount = this.hasMemberItemsTarget ? this.memberItemsTarget.children.length : 0
    const teamCount   = this.element.querySelectorAll('input[name="chat_room[parent_team_ids][]"]:checked').length
    const groupCount  = this.element.querySelectorAll('input[name="chat_room[parent_group_ids][]"]:checked').length
    return memberCount + teamCount + groupCount > 0
  }

  showStep() {
    this.stepTargets.forEach((step, index) => step.classList.toggle("hidden", index !== this.currentStep))
    if (this.hasStepFooterTarget) {
      this.stepFooterTargets.forEach((footer, index) => footer.classList.toggle("hidden", index !== this.currentStep))
    }
  }

  refreshNext() {
    if (this.hasNextButtonTarget) this.nextButtonTarget.disabled = !this.nameValid()
  }

  refreshSave() {
    if (this.hasSaveButtonTarget) this.saveButtonTarget.disabled = !this.hasAnySelection()
  }
}
